<template>
  <loader v-if="isLoader" />
  <div class="container-fluid">
    <!-- Header and Chart Row -->
    <div class="row">
      <!-- Header -->
      <div class="col-12 header">
        <div class="row">
          <div class="col-lg-3 logo-container">
             <a href="/#/" v-if="false">
            <img
              src="@/assets/images/logo-lg-light.svg"
              alt="#"
              v-if="theme == 'light'"
            />
            </a>

             <a href="/#/" v-if="false" >
            <img
              src="@/assets/images/logo-lg-medium.svg"
              alt="#"
              v-if="theme == 'medium'"
            />
            </a>

             <a href="/#/" v-if="false">
            <img
              src="@/assets/images/logo-lg-dark.svg"
              alt="#"
              v-if="theme == 'dark'"
            />
             </a>
          </div>
          <div class="col-lg-6 dash-heading-container">
            <h1 v-if="lang == 'ar'">ملخص تنفيذي</h1>
            <h1 v-if="lang == 'en'">Exectutive Summary</h1>
            <div class="line"></div>
          </div>
          <div class="col-lg-3 custom-dropdown-container">
             <div class="arrowlogo">
               <img 
              src="@/assets/images/arrow-h-dark.png"
              alt="#"
              v-if="theme == 'dark'"/>
              <img 
              src="@/assets/images/arrow-h-medium.png"
              alt="#"
              v-if="theme == 'medium'"/>
              <img 
              src="@/assets/images/arrow-h-light.png"
              alt="#"
              v-if="theme == 'light'"/>
            </div>
            <div class="togglers">
              <lang-toggler-v3></lang-toggler-v3>
              <theme-toggler-v3></theme-toggler-v3>
            </div>
          </div>
        </div>
      </div>

      <div class="row" id="databased-row">
        <div class="col-12 filter-based-data">
          <h1 v-if="lang == 'ar'">المشاریع</h1>
          <h1 v-if="lang == 'en'">All Projects</h1>
        </div>
        <div class="col-12 tab-data">
          <div
            :class="activeFilters.health == 'all' ? 'tabs active all' : 'tabs'"
            @click="filterProjects('all')"
          >
            <h1 v-if="lang == 'ar'">الكل</h1>
            <h1 v-if="lang == 'en'">All</h1>
            <div class="mark all">{{ projectData.projects.length }}</div>
          </div>
          <div
            :class="
              activeFilters.health == 'تم الاطلاق(مكتمل)'
                ? 'tabs active completed'
                : 'tabs'
            "
            @click="filterProjects('تم الاطلاق(مكتمل)')"
          >
            <h1 v-if="lang == 'ar'">تم الاطلاق(مكتمل)</h1>
            <h1 v-if="lang == 'en'">Completed</h1>
            <div class="mark completed">
              {{
                projectData.projects.filter(
                  (item) => item.ProjectStatus == "تم الاطلاق(مكتمل)"
                ).length
              }}
            </div>
          </div>
          <div
            :class="
              activeFilters.health == 'حسب المخطط'
                ? 'tabs active onplanned'
                : 'tabs'
            "
            @click="filterProjects('حسب المخطط')"
          >
            <h1 v-if="lang == 'ar'">حسب المخطط</h1>
            <h1 v-if="lang == 'en'">As Planned</h1>
            <div class="mark onplanned">
              {{
                projectData.projects.filter(
                  (item) => item.ProjectStatus == "حسب المخطط"
                ).length
              }}
            </div>
          </div>
          <div
            :class="
              activeFilters.health == 'متوقع التأخير/ملاحظة مهمة'
                ? 'tabs active expectedlate'
                : 'tabs'
            "
            @click="filterProjects('متوقع التأخير/ملاحظة مهمة')"
          >
            <h1 v-if="lang == 'ar'">متوقع التأخير</h1>
            <h1 v-if="lang == 'en'">Expected Late</h1>
            <div class="mark expectedlate">
              {{
                projectData.projects.filter(
                  (item) => item.ProjectStatus == "متوقع التأخير/ملاحظة مهمة"
                ).length
              }}
            </div>
          </div>
          <div
            :class="
              activeFilters.health == 'متأخر' ? 'tabs active late' : 'tabs'
            "
            @click="filterProjects('متأخر')"
          >
            <h1 v-if="lang == 'ar'">متأخر</h1>
            <h1 v-if="lang == 'en'">Late</h1>
            <div class="mark late">
              {{
                projectData.projects.filter(
                  (item) => item.ProjectStatus == "متأخر"
                ).length
              }}
            </div>
          </div>

          <div
          :class="
            activeFilters.health == 'ملغي'
              ? 'tabs active archived'
              : 'tabs'
          "
          @click="filterProjects('ملغي')"
        >
          <h1 v-if="lang == 'ar'">ملغي</h1>
          <h1 v-if="lang == 'en'">Archived</h1>
          <div class="mark archived">
            {{
              projectData.projects.filter(
                (item) => item.ProjectStatus == "ملغي"
              ).length
            }}
          </div>
        </div>
        </div>

        <div class="col-12 markline-container">
          <img
            src="@/assets/images/line-all.svg"
            alt="#"
            v-if="activeFilters.health == 'all'"
          />
          <!-- <img src="@/assets/images/line-dark.svg" alt="#" v-if="activeTab =='all' && theme =='dark'"> -->
          <img
            src="@/assets/images/line-late.svg"
            alt="#"
            v-if="activeFilters.health == 'متأخر'"
          />
          <img
            src="@/assets/images/line-onplanned.svg"
            alt="#"
            v-if="activeFilters.health == 'حسب المخطط'"
          />
          <img
            src="@/assets/images/line-completed.svg"
            alt="#"
            v-if="activeFilters.health == 'تم الاطلاق(مكتمل)'"
          />
          <img
            src="@/assets/images/line-expectedlate.svg"
            alt="#"
            v-if="activeFilters.health == 'متوقع التأخير/ملاحظة مهمة'"
          />
        </div>
        <div class="col-12 tile-table">
          <!-- <div class="custom-filter">
            <div
              :class="
                projectData.tableView ? 'togg table active' : 'togg table'
              "
              @click="changeProjectView('table')"
            >
              <img src="@/assets/images/icons/v3-table-view.svg" alt="#" />
            </div>
            <div
              :class="projectData.tileView ? 'togg tile active' : 'togg tile'"
              @click="changeProjectView('tile')"
            >
              <img src="@/assets/images/icons/v3-tile-view.svg" alt="#" />
            </div>
          </div> -->
          <search-filter v-if="false" />
        </div>
        <div class="panel-wrapper">
          <template
            v-for="(item, index) in Object.values(activeFilters)"
            :key="item"
          >
            <div class="current-filters" v-if="item != '' && item != 'all'">
              <span class="active-filter">{{ item }}</span>
              <img
                src="@/assets/images/icons/close-filter.svg"
                alt="#"
                v-if="theme == 'dark' || theme == 'medium'"
                @click="makeActiveFilterNone(index)"
              />
              <img
                src="@/assets/images/icons/close-filter-light.svg"
                alt="#"
                v-if="theme == 'light'"
                @click="makeActiveFilterNone(index)"
              />
            </div>
          </template>
        </div>
        <div class="col-12 filter-panel">
          <div class="dropdown-filter" @click="openProjectClassification">
            <img
              src="@/assets/images/icons/v3-angledown.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'light' || theme == 'medium'"
            />
            <img
              src="@/assets/images/icons/angle-down-td.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'dark'"
            />
            <span v-if="lang == 'en'">Project Classification</span>
            <span v-if="lang == 'ar'">تصنيف المشاريع</span>

            <div class="filter-dropdown" v-if="isProjectClassification">
              <ul>
                <li
                  @click="filterProjectsByClassification(label.key)"
                  v-for="label in projectData.catEfada.labels"
                  :key="label.key"
                >
                  {{ label.key }}
                  <span v-if="false">0</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="dropdown-filter" @click="openRFP">
            <img
              src="@/assets/images/icons/v3-angledown.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'light' || theme == 'medium'"
            />
            <img
              src="@/assets/images/icons/angle-down-td.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'dark'"
            />
            <span v-if="lang == 'en'">RFP Status</span>
            <span v-if="lang == 'ar'">كراسات الطرح</span>

            <div class="filter-dropdown" v-if="isProjectRFP">
              <ul>
                <li
                  @click="filterProjectsByRFP(label.key)"
                  v-for="label in projectData.contractStatus.labels"
                  :key="label.key"
                >
                  {{ label.key }}
                  <span v-if="false">0</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="dropdown-filter" @click="openProjectSector">
            <img
              src="@/assets/images/icons/v3-angledown.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'light' || theme == 'medium'"
            />
            <img
              src="@/assets/images/icons/angle-down-td.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'dark'"
            />
            <span v-if="lang == 'en'">Project By Sector</span>
            <span v-if="lang == 'ar'">مشاريع حسب القطاع</span>

            <div class="filter-dropdown" v-if="isProjectSector">
              <ul>
                <li
                  @click="filterProjectsBySector(label.key)"
                  v-for="label in projectData.projectSector.labels"
                  :key="label"
                >
                  {{ label.key }}
                  <span v-if="false">0</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="dropdown-filter" @click="openProjectType">
            <img
              src="@/assets/images/icons/v3-angledown.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'light' || theme == 'medium'"
            />
            <img
              src="@/assets/images/icons/angle-down-td.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'dark'"
            />
           <span v-if="lang == 'en'">Project Type</span>
          <span v-if="lang == 'ar'">نوع المشروع</span>

            <div class="filter-dropdown" v-if="isProjectType">
              <ul>
               <li @click="filterProjectsByProjectType('داخلي')">
                داخلي
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByProjectType('خارجي')">
                خارجي
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByProjectType('طلب التغيير')">
                طلب التغيير
                <span v-if="false">0</span>
              </li>
              </ul>
            </div>
          </div>
          <div class="dropdown-filter" @click="openInternalProjects">
            <img
              src="@/assets/images/icons/v3-angledown.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'light' || theme == 'medium'"
            />
            <img
              src="@/assets/images/icons/angle-down-td.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'dark'"
            />
            <span v-if="lang == 'en'">Project Phase</span>
          <span v-if="lang == 'ar'">المرحلة</span>

            <div class="filter-dropdown" v-if="isInternalProject">
              <ul>
                <li @click="filterProjectsByInternal('التنفيذ')">
                  التنفيذ
                  <span v-if="false">0</span>
                </li>
                <li @click="filterProjectsByInternal('الإغلاق')">
                  الإغلاق
                  <span v-if="false">0</span>
                </li>
                <li @click="filterProjectsByInternal('البدء')">
                  البدء
                  <span v-if="false">0</span>
                </li>
                <li @click="filterProjectsByInternal('التخطيط')">
                  التخطيط
                  <span v-if="false">0</span>
                </li>
              </ul>
            </div>
          </div>

          <div class="dropdown-filter" @click="openMiscFilter">
            <img
              src="@/assets/images/icons/v3-angledown.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'light' || theme == 'medium'"
            />
            <img
              src="@/assets/images/icons/angle-down-td.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'dark'"
            />
            <span v-if="lang == 'en'">Select Filter</span>
            <span v-if="lang == 'ar'">أختر</span>

            <div class="filter-dropdown" v-if="isMiscFilter">
              <ul>
                <li @click="filterProjectsByMisc('مبادرات مجلس الإدارة')">
                  مبادرات مجلس الإدارة
                </li>
                <li style="cursor: default; font-weight: 800 !important">
                  متوائمة
                </li>
                <li @click="filterProjectsByMisc('مشاريع السنة الحالي')">
                  مشاريع السنة 2022
                  <span v-if="false">{{
                    projects.filter((item) => {
                      let date = new Date(item.ProjectFinishDate);
                      if (
                        date.getFullYear() == new Date().getFullYear() &&
                        item.IsAligned == "نعم"
                      ) {
                        return item;
                      }
                    }).length
                  }}</span>
                </li>
                <li @click="filterProjectsByMisc('مشاريع السنة القادم')">
                  مشاريع السنة 2023
                  <span v-if="false">{{
                    projects.filter((item) => {
                      let date = new Date(item.ProjectFinishDate);
                      if (
                        date.getFullYear() == new Date().getFullYear() + 1 &&
                        item.IsAligned == "نعم"
                      ) {
                        return item;
                      }
                    }).length
                  }}</span>
                </li>
              </ul>
            </div>
          </div>

          <div class="dropdown-filter" @click="openTierFilter">
            <img
              src="@/assets/images/icons/v3-angledown.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'light' || theme == 'medium'"
            />
            <img
              src="@/assets/images/icons/angle-down-td.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'dark'"
            />
            <span v-if="lang == 'en'">Select Filter</span>
            <span v-if="lang == 'ar'">أختر</span>

            <div class="filter-dropdown" v-if="isTierVisible">
              <ul>
                <!--  <li @click="filterProjectsByTier('Special Tier (1)')">
                Special Tier (1)
                <span>{{ projects.filter(item => item.Priority == 'Special Tier (1)').length }}</span>

              </li>-->
                <li @click="filterProjectsByTier('Tier (1)')">
                  Tier (1)
                  <span v-if="false">{{
                    projects.filter((item) => item.Priority == "Tier (1)")
                      .length
                  }}</span>
                </li>
                <li @click="filterProjectsByTier('Tier (2)')">
                  Tier (2)
                  <span v-if="false">{{
                    projects.filter((item) => item.Priority == "Tier (2)")
                      .length
                  }}</span>
                </li>
                <li @click="filterProjectsByTier('Tier (3)')">
                  Tier (3)
                  <span v-if="false">{{
                    projects.filter((item) => item.Priority == "Tier (3)")
                      .length
                  }}</span>
                </li>

                 <li @click="filterProjectsByTier('لا ينطبق')">
                لا ينطبق
                <span v-if="false">{{
                  projects.filter((item) => item.Priority == "لا ينطبق").length
                }}</span>
              </li>
              </ul>
            </div>
          </div>

          <div class="dropdown-filter" @click="openAlignmentFilter">
            <img
              src="@/assets/images/icons/v3-angledown.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'light' || theme == 'medium'"
            />
            <img
              src="@/assets/images/icons/angle-down-td.svg"
              alt="#"
              class="angledown"
              v-if="theme == 'dark'"
            />
            <span v-if="lang == 'en'">هل المشروع متوائم؟</span>
            <span v-if="lang == 'ar'">هل المشروع متوائم؟</span>

            <div class="filter-dropdown" v-if="isProjectAlignment">
              <ul>
                <li @click="filterProjectsByAlignment('نعم')">
                  متوائم
                  <span v-if="false">{{
                    projects.filter((item) => item.IsAligned == "نعم").length
                  }}</span>
                </li>
                <li @click="filterProjectsByAlignment('التواريخ')">
                  غير متوائم(التواريخ)
                  <span v-if="false">{{
                    projects.filter(
                      (item) =>
                        item.IsAligned == "لا" && item.NotAligned == "التواريخ"
                    ).length
                  }}</span>
                </li>
                <li @click="filterProjectsByAlignment('النطاق')">
                  غير متوائم(النطاق)
                  <span v-if="false">{{
                    projects.filter(
                      (item) =>
                        item.IsAligned == "لا" && item.NotAligned == "النطاق"
                    ).length
                  }}</span>
                </li>
                <li @click="filterProjectsByAlignment('التواريخ و النطاق')">
                  غير متوائم(الكل)
                  <span v-if="false">{{
                    projects.filter(
                      (item) =>
                        item.IsAligned == "لا" &&
                        item.NotAligned == "التواريخ و النطاق"
                    ).length
                  }}</span>
                </li>
                <!--   <li @click="filterProjectsByAlignment('لا ينطبق')">
                لا ينطبق
                <span>{{ projects.filter(item => item.IsAligned == 'لا ينطبق').length }}</span>
                
              </li>-->
                <li @click="filterProjectsByAlignment('TBD')">
                  TBD
                  <span v-if="false">{{
                    projects.filter((item) => item.IsAligned == "TBD").length
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <project-loader v-if="isProjectLoader" />
      <div
        class="summary-chart"
        style="padding-top: 50px"
        v-if="!isProjectLoader"
      >
        <summary-chart
          id="container"
          v-if="filteredProjects"
          :dataItem="filteredProjects"
        />
      </div>

      <div v-if="false" class="col-lg-6 issues">
        <h1 class="table-title" v-if="lang == 'ar'">التحديات</h1>
        <h1 class="table-title" v-if="lang == 'en'">Issues</h1>
        <div
          :class="filter.issue == 'all' ? 'table-tiles active' : 'table-tiles'"
          @click="filterIssues('all')"
        >
          <img
            src="@/assets/images/icons/warning-all.svg"
            alt="#"
            class="icon"
            v-if="theme == 'light'"
          />
          <img
            src="@/assets/images/icons/v3-issue-all.svg"
            alt="#"
            class="icon"
            v-if="theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/warning-all-dark.svg"
            alt="#"
            class="icon"
            v-if="theme == 'dark'"
          />

          <h1 v-if="lang == 'ar'">الكل</h1>
          <h1 v-if="lang == 'en'">All</h1>
          <h2>10</h2>
        </div>
        <div
          :class="filter.issue == 'high' ? 'table-tiles active' : 'table-tiles'"
          @click="filterIssues('high')"
        >
          <img
            src="@/assets/images/icons/warning-high.svg"
            alt="#"
            class="icon"
          />
          <h1 v-if="lang == 'ar'">ارتفاع</h1>
          <h1 v-if="lang == 'en'">High</h1>
          <h2>2</h2>
        </div>
        <div
          :class="
            filter.issue == 'medium' ? 'table-tiles active' : 'table-tiles'
          "
          @click="filterIssues('medium')"
        >
          <img
            src="@/assets/images/icons/warning-moderate.svg"
            alt="#"
            class="icon"
          />
          <h1 v-if="lang == 'ar'">متوسط</h1>
          <h1 v-if="lang == 'en'">Medium</h1>
          <h2>3</h2>
        </div>
        <div
          :class="
            filter.issue == 'low'
              ? 'table-tiles active last'
              : 'table-tiles last'
          "
          @click="filterIssues('low')"
        >
          <img
            src="@/assets/images/icons/v3-issue-low.svg"
            alt="#"
            class="icon"
            v-if="theme == 'medium' || theme == 'light'"
          />
          <img
            src="@/assets/images/icons/warning-less.svg"
            alt="#"
            class="icon"
            v-if="theme == 'dark'"
          />

          <h1 v-if="lang == 'ar'">ليلق</h1>
          <h1 v-if="lang == 'en'">Low</h1>
          <h2>6</h2>
        </div>

        <table class="issue-table">
          <thead>
            <tr>
              <th>إسم المشروع</th>
              <th>تاریخ الإطلاق</th>
              <th class="center">الحالة</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="issue in filteredIssues" :key="issue.status">
              <td>{{ issue.name }}</td>
              <td class="date">{{ issue.date }}</td>
              <td class="center">
                <span v-if="issue.code == 'low'" class="low">{{
                  issue.status
                }}</span>
                <span v-if="issue.code == 'medium'" class="medium">{{
                  issue.status
                }}</span>
                <span v-if="issue.code == 'high'" class="high">{{
                  issue.status
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <FooterUnfixed/>

  </div>
</template>





<script>
import store from "@/store";
import router from "@/router";
// import Swal from "sweetalert2";

// import Swal from 'sweetalert2'
import axios from "axios"; //uncomment when using api
import ThemeTogglerV3 from "@/components/theme-toggler-v3.vue";
import LangTogglerV3 from "@/components/lang-toggler-v3.vue";
import SummaryChart from "@/components/charts/summary-chart.vue";
import FooterUnfixed from "@/components/footer-unfixed.vue";


// import $ from 'jquery';

// Local data fetch for testign
import { projects } from "@/static/projectdataset.js";
// import { projects } from "@/static/bulkdataset.js";
import { risks } from "@/static/riskprojects.js";
import { milestones } from "@/static/milestones.js";

// Components
// import Loader from "@/components/loader.vue";
import ProjectLoader from "@/components/project-loader.vue";
// import HalfCutProgressV3 from "@/components/charts/half-cut-progress-v3.vue";
// import HalfcutProgressLite from "@/components/charts/half-cut-progress-lite.vue";
// import SearchFilter from "@/components/search-filter.vue";

export default {
  name: "Executive Summary",
  components: {
    ThemeTogglerV3,
    LangTogglerV3,
    SummaryChart,
    ProjectLoader,
    FooterUnfixed

  },
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
    env() {
      return store.getters.getEnv;
    },
    projects() {
      return store.getters.getProjects;
    },
    filteredProjects() {
      return store.getters.getFilteredProjects;
    },
    activeTab() {
      return store.getters.getActiveTab;
    },
    activeFilter() {
      return store.getters.getActiveFilter;
    },
    projectLoader() {
      return this.isProjectLoader;
    },
  },
  data() {
    return {
      isLoader: false,
      isProjectLoader: false,
      isTierVisible: false,
      isProjectAlignment: false,
      isMiscFilter: false,
      isInternalProject: false,
      isExternalProject: false,
      isProjectSector: false,
      isProjectRFP: false,
      isProjectClassification: false,
      isProjectType:false,
      filteredRisks: null,
      filteredIssues: null,
      filter: {
        risk: "all",
        issue: "all",
      },
      activeFilters: {
        health: "all",
        tier: "",
        alignment: "",
        misc: "",
        internal: "",
         projectType: "",
        sector: "",
        rfp: "",
        classification: "",
      },
      fireSwal: false,
      projectData: {
        risks: [],
        issues: [],
        milestones: [],
        projects: [],
        tileView: true,
        tableView: false,
        contractValue: 0,
        approvedBudget: 0,
        paidAmount: 0,
        risk: {
          veryHigh: 0,
          high: 0,
          moderate: 0,
          low: 0,
          nonImpact: 0,
        },
        currentYear: {
          contractValue: 0,
          approvedBudget: 0,
          totalProject: 0,
          paidAmount: 0,
        },
        progressChart: {
          allPercentageValue: 0,
          currentYearPercentageValue: 0,
        },
        pieChart: {
          isData: false,
          late: 0,
          expectedLate: 0,
          completed: 0,
          onplanned: 0,
        },
        internalProjects: {
          isData: false,
          executed: 0,
          planned: 0,
          opened: 0,
          closed: 0,
        },
         projectType: {
          isData: false,
          external: 0,
          internal: 0,
          changeRequest: 0,
        },
        externalProjects: {
          isData: false,
          executed: 0,
          planned: 0,
          opened: 0,
          closed: 0,
        },
        projectSector: {
          isData: false,
          totalSectors: 0,
          labels: [],
        },
        contractStatus: {
          isData: false,
          labels: [],
          totalContracts: 0,
          colors: [
            { stop1: "#85D7E0", stop2: "#85D7E0" },
            { stop1: "#9DF0FA", stop2: "#9DF0FA" },
            { stop1: "#78D3DC", stop2: "#78D3DC" },
            { stop1: "#5EBEC8", stop2: "#5EBEC8" },
            { stop1: "#399CA6", stop2: "#399CA6" },
            { stop1: "#2CA4B1", stop2: "#2CA4B1" },
            { stop1: "#2D7880", stop2: "#2D7880" },
            { stop1: "#13565C", stop2: "#13565C" },
            { stop1: "#238D98", stop2: "#238D98" },
            { stop1: "#2CA4B1", stop2: "#2CA4B1" },
            { stop1: "#31B1BF", stop2: "#31B1BF" },
            { stop1: "#3ABDCB", stop2: "#3ABDCB" },
          ],
        },
        catEfada: {
          isData: false,
          labels: [],
          totalEfada: 0,
          colors: [
            { stop1: "#6F98B2", stop2: "#6F98B2" },
            { stop1: "#85ABC3", stop2: "#85ABC3" },
            { stop1: "#C3E8FF", stop2: "#C3E8FF" },
            { stop1: "#99D8FE", stop2: "#99D8FE" },
            { stop1: "#4EABE3", stop2: "#4EABE3" },
            { stop1: "#3091CC", stop2: "#3091CC" },
            { stop1: "#0B4C73", stop2: "#0B4C73" },
            { stop1: "#7CEDE8", stop2: "#7CEDE8" },
            { stop1: "#105B89", stop2: "#105B89" },
            { stop1: "#166B9E", stop2: "#166B9E" },
            { stop1: "#1978B2", stop2: "#1978B2" },
          ],
        },
      },
    };
  },
  methods: {
    navigate: function (page) {
      router.push(page);
    },

    openTierFilter: function () {
      this.isTierVisible = !this.isTierVisible;
      this.isProjectAlignment = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    openAlignmentFilter: function () {
      this.isProjectAlignment = !this.isProjectAlignment;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    openInternalProjects: function () {
      this.isInternalProject = !this.isInternalProject;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
     openProjectType: function () {
      this.isProjectType = !this.isProjectType;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    openExternalProjects: function () {
      this.isExternalProject = !this.isExternalProject;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    openProjectSector: function () {
      this.isProjectSector = !this.isProjectSector;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    openRFP: function () {
      this.isProjectRFP = !this.isProjectRFP;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectClassification = false;
    },
    openProjectClassification: function () {
      this.isProjectClassification = !this.isProjectClassification;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
    },
    openMiscFilter: function () {
      this.isMiscFilter = !this.isMiscFilter;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    getOnlyDate: function (dateTime) {
      let date = new Date(dateTime);
      let year = date.getFullYear();
      let month =
        date.getMonth().toString().length > 1
          ? date.getMonth()
          : "0" + date.getMonth();
      let day =
        date.getDate().toString().length > 1
          ? date.getDate()
          : "0" + date.getDate();
      month = parseInt(month) + 1;
      let dateWithoutTime = day + "-" + month + "-" + year;
      return dateWithoutTime;
    },
    filterProjects: async function (filter) {
      // Showing Project Loader
      this.isProjectLoader = true;
      this.activeFilters.health = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByTier: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.tier = filter;
      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByAlignment: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.alignment = filter;
      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByMisc: async function (filter) {
      // Showing Loader

      this.isProjectLoader = true;
      this.activeFilters.misc = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByInternal: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.internal = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
     filterProjectsByProjectType: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.projectType = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsBySector: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.sector = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByRFP: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.rfp = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
       this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByClassification: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.classification = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
       this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    applyHealth() {
      // Applying New Filter
      if (this.activeFilters.health == "all") {
        store.dispatch("setFilteredProjects", store.getters.getProjects);
      } else {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getProjects.filter(
            (item) => item.ProjectStatus == this.activeFilters.health
          )
        );
        // }
      }
    },
    applyTier() {
      if (this.activeFilters.tier != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) => item.Priority == this.activeFilters.tier
          )
        );
      }
    },
    applyAlignment() {
      if (this.activeFilters.alignment != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter((item) => {
            if (
              this.activeFilters.alignment == "نعم" ||
              this.activeFilters.alignment == "لا ينطبق" ||
              this.activeFilters.alignment == "TBD"
            ) {
              return item.IsAligned == this.activeFilters.alignment;
            } else if (
              (item.IsAligned == "لا" &&
                this.activeFilters.alignment == "التواريخ") ||
              (item.IsAligned == "لا" &&
                this.activeFilters.alignment == "النطاق") ||
              (item.IsAligned == "لا" &&
                this.activeFilters.alignment == "التواريخ و النطاق")
            ) {
              return item.NotAligned == this.activeFilters.alignment;
            }
          })
        );
      }
    },
    applyMisc() {
      if (this.activeFilters.misc == "مبادرات مجلس الإدارة") {
        // Applying New Filter
        store.dispatch(
          "setFilteredProjects",

          store.getters.getFilteredProjects.filter(
            (item) => item.boardinitiative == "نعم"
          )
        );
      }

      if (this.activeFilters.misc == "مشاريع السنة الحالي") {
        // Applying New Filter
        store.dispatch(
          "setFilteredProjects",

          store.getters.getFilteredProjects.filter((item) => {
            let date = new Date(item.ProjectFinishDate);
            if (
              date.getFullYear() == new Date().getFullYear() &&
              item.IsAligned == "نعم"
            ) {
              return item;
            }
          })
        );
      }
      //
      if (this.activeFilters.misc == "مشاريع السنة القادم") {
        store.dispatch(
          "setFilteredProjects",

          store.getters.getFilteredProjects.filter((item) => {
            let date = new Date(item.ProjectFinishDate);
            if (
              date.getFullYear() == new Date().getFullYear() + 1 &&
              item.IsAligned == "نعم"
            ) {
              return item;
            }
          })
        );
      }
    },
    applyInternal() {
      if (this.activeFilters.internal != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) =>
              item.ProjectType == "داخلي" &&
              item.ProjectPhase == this.activeFilters.internal
          )
        );
      }
    },
    applyExternal() {
      if (this.activeFilters.external != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) =>
              item.ProjectType == "خارجي" &&
              item.ProjectPhase == this.activeFilters.external
          )
        );
      }
    },
    applyProjectType() {
      if (this.activeFilters.projectType != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) => item.ProjectType == this.activeFilters.projectType
          )
        );
      }
    },
    applySector() {
      if (this.activeFilters.sector != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) => item.ProjectSector == this.activeFilters.sector
          )
        );
      }
    },
    applyRFP() {
      if (this.activeFilters.rfp != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) => item.ContractStatus == this.activeFilters.rfp
          )
        );
      }
    },
    applyClassification() {
      if (this.activeFilters.classification != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) => item.cat_efada == this.activeFilters.classification
          )
        );
      }
    },
    makeActiveFilterNone: function (index) {
      if (index == 0) {
        this.activeFilters.health = "all";
      }
      if (index == 1) {
        this.activeFilters.tier = "";
      }
      if (index == 2) {
        this.activeFilters.alignment = "";
      }
      if (index == 3) {
        this.activeFilters.misc = "";
      }
      if (index == 4) {
        this.activeFilters.internal = "";
      }
       if (index == 5) {
        this.activeFilters.projectType = "";
      }
      if (index == 6) {
        this.activeFilters.sector = "";
      }
      if (index == 7) {
        this.activeFilters.rfp = "";
      }
      if (index == 8) {
        this.activeFilters.classification = "";
      }

      this.isProjectLoader = true;

      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    disableDropdowns() {
      var binder = this;
      document.addEventListener("DOMContentLoaded", function () {
        let body = document.querySelector("body");
        body.addEventListener("click", function (e) {
          if (
            !(
              e.target.classList.contains("dropdown-filter") ||
              e.target.parentNode.classList.contains("dropdown-filter")
            )
          ) {
            console.log("in if");
            binder.isTierVisible = false;
            binder.isProjectAlignment = false;
            binder.isMiscFilter = false;
            binder.isInternalProject = false;
            binder.isExternalProject = false;
            binder.isProjectSector = false;
            binder.isProjectRFP = false;
            binder.isProjectClassification = false;
            binder.isProjectType = false;
          }
        });
      });
    },
    calculateProjectSector: function () {
      const uniques = this.projectData.projects
        .map((item) => item.ProjectSector)
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < uniques.length; i++) {
        const feed = {};
        feed.key = uniques[i];
        feed.value = 0;
        this.projectData.projectSector.labels.push(feed);
      }

      // Now getting count
      for (let i = 0; i < this.projectData.projects.length; i++) {
        for (let j = 0; j < this.projectData.projectSector.labels.length; j++) {
          if (
            this.projectData.projects[i].ProjectSector ==
            this.projectData.projectSector.labels[j].key
          ) {
            this.projectData.projectSector.labels[j].value++;
          }
        }
      }
      for (let j = 0; j < this.projectData.projectSector.labels.length; j++) {
        this.projectData.projectSector.totalSectors +=
          this.projectData.projectSector.labels[j].value;
      }
      // Insertion Sort Logic for labels
      this.insertionSort(this.projectData.projectSector.labels);
      this.projectData.projectSector.isData = true;
    },
    calculateContractStatus: function () {
      let newData = this.projectData.projects.filter(
        (item) => item.ContractStatus != null && item.ContractStatus != ""
      );
      const uniques = newData
        .map((item) => item.ContractStatus.trim())
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < uniques.length; i++) {
        const feed = {};
        feed.key = uniques[i];
        feed.value = 0;
        this.projectData.contractStatus.labels.push(feed);
      }

      // Now getting count
      for (let i = 0; i < this.projectData.projects.length; i++) {
        for (
          let j = 0;
          j < this.projectData.contractStatus.labels.length;
          j++
        ) {
          if (
            this.projectData.projects[i].ContractStatus ==
            this.projectData.contractStatus.labels[j].key
          ) {
            this.projectData.contractStatus.labels[j].value++;
          }
        }
      }
      for (let j = 0; j < this.projectData.contractStatus.labels.length; j++) {
        this.projectData.contractStatus.totalContracts +=
          this.projectData.contractStatus.labels[j].value;
      }
      this.insertionSort(this.projectData.contractStatus.labels);
      this.projectData.contractStatus.isData = true;
    },
    calculateCatEfadaStatus: function () {
      let newData = this.projectData.projects.filter(
        (item) => item.cat_efada != null && item.cat_efada != ""
      );
      const uniques = newData
        .map((item) => item.cat_efada.trim())
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < uniques.length; i++) {
        const feed = {};
        feed.key = uniques[i];
        feed.value = 0;
        this.projectData.catEfada.labels.push(feed);
      }

      // Now getting count
      for (let i = 0; i < this.projectData.projects.length; i++) {
        for (let j = 0; j < this.projectData.catEfada.labels.length; j++) {
          if (
            this.projectData.projects[i].cat_efada ==
            this.projectData.catEfada.labels[j].key
          ) {
            this.projectData.catEfada.labels[j].value++;
          }
        }
      }
      for (let j = 0; j < this.projectData.catEfada.labels.length; j++) {
        this.projectData.catEfada.totalEfada +=
          this.projectData.catEfada.labels[j].value;
      }
      this.insertionSort(this.projectData.catEfada.labels);

      this.projectData.catEfada.isData = true;
    },
    calculateProjectType: function () {
      for (let i = 0; i < this.projectData.projects.length; i++) {
        
          if (this.projectData.projects[i].ProjectType == "داخلي") {
            this.projectData.projectType.internal++;
          }
          if (this.projectData.projects[i].ProjectType == "خارجي") {
            this.projectData.projectType.external++;
          }
          if (this.projectData.projects[i].ProjectType == "طلب التغيير") {
            this.projectData.projectType.changeRequest++;
          }  
        
      }
      this.projectData.projectType.isData = true;
    },
    insertionSort: function (inputArr) {
      let n = inputArr.length;
      for (let i = 1; i < n; i++) {
        // Choosing the first element in our unsorted subarray
        let current = inputArr[i];
        // The last element of our sorted subarray
        let j = i - 1;
        while (j > -1 && current.value < inputArr[j].value) {
          inputArr[j + 1] = inputArr[j];
          j--;
        }
        inputArr[j + 1] = current;
      }
      // return inputArr;
    },
    
  },
  async mounted() {
    //newcode
    // Fetching from api uncomment below three lines if using api
    if (this.env == "prod") {
      try {
        this.isLoader = true;
        const response = await axios.get(
          "https://pmoapi.sdb.gov.sa/api/proj/0",
          { withCredentials: true }
        );

        this.projectData.projects = JSON.parse(response.data[0]);
        this.projectData.risks = JSON.parse(response.data[1]);
        this.projectData.milestones = JSON.parse(response.data[1]);

        this.isLoader = false;
      } catch (error) {
        console.log(error);
      }
    }
    if (this.env == "dev") {
      this.projectData.projects = projects;
      this.projectData.risks = risks;
      this.projectData.milestones = milestones;
    }

    this.filteredRisks = this.projectData.risks;
    this.filteredIssues = this.projectData.issues;

     // Calculate Pie Filter chart value and percentage of Project Sectors
    this.calculateProjectSector();

    // Calculate Pie Filter chart value and percentage of Contract Value
    this.calculateContractStatus();

    // Calculate Pie Filter chart value and percentage of Cat Efada
    this.calculateCatEfadaStatus();

    this.calculateProjectType();


    store.dispatch("setProjects", this.projectData.projects);
    store.dispatch("setFilteredProjects", this.projectData.projects);

    // Disabling Dropdowns
    this.disableDropdowns();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/global.scss";

body.ar {
  direction: rtl;
}
body.en {
  direction: ltr;
}

body.theme-light {
  background: $primary-background-light-v3;
}
body.theme-dark {
  background: $primary-background-dark-v3;
}
body.theme-medium {
  background: $primary-background-medium-v3;
}
</style>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
@import "@/assets/css/common.scss";

body.theme-dark.ar {
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 66px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
      margin-bottom: 50px;
      margin-left: 45px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-dark-secondarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #fff);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
      }
    }
  }
}
body.theme-medium.ar {
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 66px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
      margin-bottom: 50px;
      margin-left: 45px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-medium-primarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #000);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
      }
    }
  }
}
body.theme-light.ar {
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 66px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorder;
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);
      margin-bottom: 50px;
      margin-left: 45px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-light-primarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #000);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
      }
    }
  }
}

body.theme-dark.en {
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 66px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
      margin-bottom: 50px;
      margin-right: 45px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-right: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-dark-secondarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #fff);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
      }
    }
  }
}
body.theme-medium.en {
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 66px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
      margin-bottom: 50px;
      margin-right: 45px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-medium-primarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #000);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
      }
    }
  }
}
body.theme-light.en {
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 66px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorder;
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);
      margin-bottom: 50px;
      margin-right: 45px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-right: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-light-primarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #000);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
@import "@/assets/css/v3-dash-ar-lmd";
@import "@/assets/css/v3-dash-en-lmd";
</style>
